import script from "./Inventory.vue?vue&type=script&setup=true&lang=js"
export * from "./Inventory.vue?vue&type=script&setup=true&lang=js"

import "./Inventory.vue?vue&type=style&index=0&id=608bd749&lang=css"

const __exports__ = script;

export default __exports__